/**
 * Single source of truth for the 10-step edit-object wizard structure.
 *
 * `optional: true` steps render under a collapsible "Optional steps" group
 * in the sidebar. Required steps (Upload Images, Describe Artwork, Review)
 * always show; the optional group expands automatically when the active
 * step lives inside it.
 */
export interface EditObjectStep {
  id: string;
  label: string;
  optional?: boolean;
}

export const EDIT_OBJECT_STEPS: readonly EditObjectStep[] = Object.freeze([
  { id: 'images', label: 'Images' },
  { id: 'describe', label: 'Artwork Details' },
  { id: 'getty', label: 'Getty Vocab', optional: true },
  { id: 'provenance', label: 'Provenance', optional: true },
  { id: 'exhibitions', label: 'Exhibitions', optional: true },
  { id: 'publications', label: 'Publications', optional: true },
  { id: 'awards', label: 'Awards & Honors', optional: true },
  { id: 'related', label: 'Related Works', optional: true },
  { id: 'catalog', label: 'Inventory & Albums', optional: true },
  { id: 'additional', label: 'Always Private', optional: true },
  { id: 'review', label: 'Review & Visibility' },
]);

export type EditObjectStepId = (typeof EDIT_OBJECT_STEPS)[number]['id'];
